'use strict';

var _extends = require('babel-runtime/helpers/extends')['default'];

exports.__esModule = true;
exports['default'] = reducer;
exports.setStatus = setStatus;
var SET_STATUS = '@@invoice/SET_STATUS';
var SET_STATUS_SUCCESS = '@@invoice/SET_STATUS_SUCCESS';
var SET_STATUS_FAIL = '@@invoice/SET_STATUS_FAIL';

var initialState = {
  pending: false
};

function reducer() {
  var state = arguments.length <= 0 || arguments[0] === undefined ? initialState : arguments[0];
  var action = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];

  switch (action.type) {
    case SET_STATUS:
      return _extends({}, state, {
        pending: true
      });
    case SET_STATUS_SUCCESS:
      return _extends({}, state, {
        pending: false
      });
    case SET_STATUS_FAIL:
      return _extends({}, state, {
        pending: false
      });

    default:
      return state;
  }
}

function setStatus(qa, status) {
  return {
    types: [SET_STATUS, SET_STATUS_SUCCESS, SET_STATUS_FAIL],
    promise: function promise(client) {
      return client.call('invoice.setStatus', { qa: qa, status: status }, { progress: true });
    }
  };
}


/*****************
 ** WEBPACK FOOTER
 ** ./src/redux/modules/invoice.js
 ** module id = 1058
 ** module chunks = 2
 **/